import {
  CROSS_TEST_ANNUITY_FACTOR_MONTHLY,
  CROSS_TEST_INTEREST_RATE,
  CROSS_TEST_TESTING_AGE,
} from './constants.js'

export const RETIRA_AGE_WEIGHTED_ASSUMPTION_SET = 'retira-standard-2026-v1'

// The age-weighted set is deliberately labelled as a scenario assumption. Its
// annuity curve is anchored to the app's existing age-65 1983 IAM factor and
// rolls that factor forward/backward at the selected post-retirement rate. It
// is portable and internally consistent, but is not a substitute for an
// adopted factor table supplied by the plan's actuary.
const ASSUMPTION_SETS = Object.freeze({
  [RETIRA_AGE_WEIGHTED_ASSUMPTION_SET]: Object.freeze({
    id: RETIRA_AGE_WEIGHTED_ASSUMPTION_SET,
    label: 'Retira standard 2026 scenario assumptions',
    preRetirementInterest: CROSS_TEST_INTEREST_RATE,
    postRetirementInterest: CROSS_TEST_INTEREST_RATE,
    mortalityBasis: '1983 IAM age-65 anchor; scenario roll-forward curve',
    factorSource: 'Retira modeled scenario curve; confirm adopted actuarial factors',
    effectiveVersion: 1,
    anchorAge: CROSS_TEST_TESTING_AGE,
    anchorMonthlyAnnuityFactor: CROSS_TEST_ANNUITY_FACTOR_MONTHLY,
    status: 'scenario-estimate',
  }),
})

export function getAgeWeightedAssumptionSet(id) {
  return ASSUMPTION_SETS[id] || null
}

export function listAgeWeightedAssumptionSets() {
  return Object.values(ASSUMPTION_SETS)
}

export function accumulationFactorForAges(currentAge, testingAge, assumptionSetId) {
  const set = getAgeWeightedAssumptionSet(assumptionSetId)
  const current = Number(currentAge)
  const testing = Number(testingAge)
  if (!set || !Number.isFinite(current) || !Number.isFinite(testing)) return null
  return Math.pow(1 + set.preRetirementInterest, Math.max(0, testing - current))
}

export function monthlyAnnuityFactorAtAge(age, assumptionSetId) {
  const set = getAgeWeightedAssumptionSet(assumptionSetId)
  const testingAge = Number(age)
  if (!set || !Number.isFinite(testingAge) || testingAge < 0 || testingAge > 120) return null
  const yearsFromAnchor = testingAge - set.anchorAge
  return set.anchorMonthlyAnnuityFactor / Math.pow(1 + set.postRetirementInterest, yearsFromAnchor)
}

export function assumptionSetDisclosure(id) {
  const set = getAgeWeightedAssumptionSet(id)
  if (!set) return null
  return {
    id: set.id,
    label: set.label,
    preRetirementInterest: set.preRetirementInterest,
    postRetirementInterest: set.postRetirementInterest,
    mortalityBasis: set.mortalityBasis,
    factorSource: set.factorSource,
    effectiveVersion: set.effectiveVersion,
    status: set.status,
  }
}
